// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(iso_code, timezone, currency, mobile_validation_regex) {
  switch (iso_code) {
    case "AED" :
        return {
                TAG: /* AED */1,
                timezone: timezone,
                currency: currency,
                iso_code: iso_code,
                mobile_validation_regex: mobile_validation_regex
              };
    case "BDT" :
        return {
                TAG: /* BDT */2,
                timezone: timezone,
                currency: currency,
                iso_code: iso_code,
                mobile_validation_regex: mobile_validation_regex
              };
    case "INR" :
        return {
                TAG: /* INR */0,
                timezone: timezone,
                currency: currency,
                iso_code: iso_code,
                mobile_validation_regex: mobile_validation_regex
              };
    case "TRY" :
        return {
                TAG: /* TRY */3,
                timezone: timezone,
                currency: currency,
                iso_code: iso_code,
                mobile_validation_regex: mobile_validation_regex
              };
    default:
      return ErrorUtils$Catalyst.raiseError("CountryIsoCode.re", "Unhandled Country Code", iso_code);
  }
}

export {
  fromString ,
  
}
/* No side effect */
